import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-student-parent-hub',
  templateUrl: './student-parent-hub.component.html',
  styleUrls: ['./student-parent-hub.component.scss']
})
export class StudentParentHubComponent implements OnInit {

  @ViewChild('parentVideo') parentVideoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('studentVideo') studentVideoRef!: ElementRef<HTMLVideoElement>;

  parentPlaying = false;
  studentPlaying = false;

  parentElapsed = '00:00';
  parentDuration = '01:45';
  
  studentElapsed = '00:00';
  studentDuration = '01:38';

  parentProgress = 0;
  studentProgress = 0;

  constructor() { }

  ngOnInit(): void { }

  toggleParentVideo(): void {
    const video = this.parentVideoRef.nativeElement;
    if (this.parentPlaying) {
      video.pause();
      this.parentPlaying = false;
    } else {
      video.play();
      this.parentPlaying = true;
      // Pause student video if playing
      if (this.studentPlaying) {
        this.studentVideoRef.nativeElement.pause();
        this.studentPlaying = false;
      }
    }
  }

  toggleStudentVideo(): void {
    const video = this.studentVideoRef.nativeElement;
    if (this.studentPlaying) {
      video.pause();
      this.studentPlaying = false;
    } else {
      video.play();
      this.parentPlaying = false; // Mutually exclusive
      this.studentPlaying = true;
      // Pause parent video if playing
      if (this.parentPlaying) {
        this.parentVideoRef.nativeElement.pause();
        this.parentPlaying = false;
      }
    }
  }

  onParentTimeUpdate(): void {
    const video = this.parentVideoRef.nativeElement;
    this.parentProgress = (video.currentTime / video.duration) * 100;
    this.parentElapsed = this.formatTime(video.currentTime);
    this.parentDuration = this.formatTime(video.duration || 105);
  }

  onStudentTimeUpdate(): void {
    const video = this.studentVideoRef.nativeElement;
    this.studentProgress = (video.currentTime / video.duration) * 100;
    this.studentElapsed = this.formatTime(video.currentTime);
    this.studentDuration = this.formatTime(video.duration || 98);
  }

  onParentEnded(): void {
    this.parentPlaying = false;
    this.parentProgress = 0;
    this.parentElapsed = '00:00';
  }

  onStudentEnded(): void {
    this.studentPlaying = false;
    this.studentProgress = 0;
    this.studentElapsed = '00:00';
  }

  toggleParentFullscreen(event: Event): void {
    event.stopPropagation();
    const video = this.parentVideoRef.nativeElement;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
  }

  toggleStudentFullscreen(event: Event): void {
    event.stopPropagation();
    const video = this.studentVideoRef.nativeElement;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
  }

  private formatTime(seconds: number): string {
    if (isNaN(seconds)) return '00:00';
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  }

}


